import { createRouter, createWebHistory } from 'vue-router';
import MemberDashboard from '../views/member/Dashboard.vue';
import AdminDashboard from '../views/admin/Dashboard.vue';
import LoginView from '../views/Login.vue';
import SignupView from '../views/Signup.vue';
import PackagePurchase from '../views/member/PackagePurchase.vue';

// [추가됨] 신규 회원 메뉴 컴포넌트 임포트
import WalletWithdrawal from '../views/member/WalletWithdrawal.vue';
import GenealogyTree from '../views/member/GenealogyTree.vue';
import ProfileEdit from '../views/member/ProfileEdit.vue';

import { auth, db } from '../firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';

const routes = [
  {
    path: '/',
    name: 'MemberDashboard',
    component: MemberDashboard,
    meta: { requiresAuth: true }
  },
  {
    path: '/package-purchase',
    name: 'PackagePurchase',
    component: PackagePurchase,
    meta: { requiresAuth: true }
  },
  // [추가됨] 지갑/출금 라우트
  {
    path: '/wallet',
    name: 'WalletWithdrawal',
    component: WalletWithdrawal,
    meta: { requiresAuth: true }
  },
  // [추가됨] 조직도/계보도 라우트
  {
    path: '/tree',
    name: 'GenealogyTree',
    component: GenealogyTree,
    meta: { requiresAuth: true }
  },
  // [추가됨] 정보수정 라우트
  {
    path: '/profile',
    name: 'ProfileEdit',
    component: ProfileEdit,
    meta: { requiresAuth: true }
  },
  {
    path: '/admin',
    name: 'AdminDashboard',
    component: AdminDashboard,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginView
  },
  {
    path: '/signup',
    name: 'Signup',
    component: SignupView
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

const getCurrentUser = () => {
  return new Promise((resolve, reject) => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      unsubscribe();
      if (user) {
        try {
          const docRef = doc(db, 'users', user.uid);
          const docSnap = await getDoc(docRef);
          if (docSnap.exists()) {
            user.role = docSnap.data().role;
          }
        } catch (e) {
          console.error("Failed to fetch user role", e);
        }
      }
      resolve(user);
    }, reject);
  });
};

// 권한 확인 및 리다이렉트 로직 유지
router.beforeEach(async (to) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const requiresAdmin = to.matched.some(record => record.meta.requiresAdmin);
  const currentUser = await getCurrentUser();

  if (requiresAuth && !currentUser) {
    return '/login';
  } else if ((to.name === 'Login' || to.name === 'Signup') && currentUser) {
    return currentUser.role === 'admin' ? '/admin' : '/';
  } else if (requiresAdmin && currentUser?.role !== 'admin') {
    return '/';
  }
});

export default router;